import config from "../config";

const baseUrl = config.base_url + "container_reproductive_report_generated/";

// 用于 container_reproductive_report_generated 相关接口
export default {
  // GET /site/container_reproductive_report_generated/listByFarmRegionAndDate
  listByFarmRegionAndDate: {
    url: baseUrl + "listByFarmRegionAndDate",
    type: "get",
  },

  // POST /site/container_reproductive_report_generated/generateByTemplate
  generateByTemplate: {
    url: baseUrl + "generateByTemplate",
    type: "post",
  },
};

